export default "__VITE_ASSET__8fd1b146__"